import TestimonyImageModelCommon from 'common/models/testimony-image';

export default class TestimonyImageModel extends TestimonyImageModelCommon {}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'testimony-image': TestimonyImageModel;
  }
}
